import React from 'react';
import { Grid } from 'react-flexbox-grid';
import PropTypes from 'prop-types';

import CommonHeader from 'routes/Documents/components/CommonHeader';
import BottomFormControls from 'routes/Documents/components/BottomFormControls';
import { getLatestFinishedCommitData, getLatestUnfinishedCommit } from 'lib/documentHandling';
import EditableV2 from 'routes/Documents/containers/EditableV2';

import EditLogContainer from 'containers/EditLogContainer';
import Paper from 'components/Paper';

import Form from './Form';

const labelAccessor = id => `benefits.labels.${id}`;
const optionAccessor = id => `benefits.opts.${id}`;

const Benefits = ({ names, documents, editingDocument, onStartEdit, onCreate }) => {
  const benefitsDoc = documents[0] || null;

  return (
    <div>
      <Paper topMargin={false}>
        <Grid fluid>
          <CommonHeader
            names={names}
            localeId="benefits.title"
            infoText="benefits.infoText"
            editing={editingDocument}
            startEdit={name => {
              if (!benefitsDoc) {
                onCreate(name);
              } else onStartEdit(name, benefitsDoc.documentId, getLatestFinishedCommitData(benefitsDoc));
            }}
          />
        </Grid>
        {editingDocument && (
          <EditableV2
            documentId={editingDocument.documentId}
            moduleName={names[0]}
            editedCommit={getLatestUnfinishedCommit(editingDocument)}
          >
            <Form />
          </EditableV2>
        )}
        {!editingDocument && benefitsDoc ? (
          <Form editing={false} formValues={getLatestFinishedCommitData(benefitsDoc)} />
        ) : null}
      </Paper>
      {editingDocument && (
        <BottomFormControls
          name={names[0]}
          editId={editingDocument.documentId}
          commitId={getLatestUnfinishedCommit(editingDocument).commitId}
        />
      )}
      {!editingDocument && benefitsDoc ? (
        <Paper>
          <EditLogContainer form={benefitsDoc} labelAccessor={labelAccessor} optionAccessor={optionAccessor} />
        </Paper>
      ) : null}
    </div>
  );
};

Benefits.propTypes = {
  names: PropTypes.array,
  documents: PropTypes.array,
  onStartEdit: PropTypes.func.isRequired,
  onCreate: PropTypes.func.isRequired,
  editingDocument: PropTypes.oneOfType([PropTypes.bool, PropTypes.object]),
};

export default Benefits;
